import React from 'react'
import './index.scss'
import rightBtn from '@/assets/images/rightbtn.png'
import { Bscroll } from '@/components/bscroll'
// import { connect } from 'react-redux'
// import { termsUpdataAction } from '@/store/actions/termsUpdateAction'

// const mapStateToProps = (state) => ({
//     updateList: state.getIn(['termsUpdateReducer', 'updateList'])
// })
// const mapDispatchToProps = (dispatch) => ({
//     // 获取条款更新
//     handleGetUpdateList() {
//         return dispatch(termsUpdataAction())
//     }
// })

const TermsUpdate = (props) => {
    let {history} = props
    // let [count, setCount] = useState(3);
    // let { updateList, handleGetUpdateList } = props
    //按钮倒计时
    // const acceptBtn = () => {
    //     let timer = setInterval(() => {
    //         clearInterval(timer);
    //         if (count < 0) {
    //             clearInterval(timer);
    //         } else {
    //             setCount(_ => count - 1);
    //         }
    //     }, 1000)
    // }
    // acceptBtn();

    // useEffect(() => {
    //     handleGetUpdateList()
    // }, [handleGetUpdateList])
    //接受按钮
    // const handleAcceptBtn = () => {
    //     console.log('接受');
    // }
    // //拒绝按钮
    // const handleRejectBtn = () => {
    //     console.log('拒绝')
    // }
    return (
        <div className="terms-update__box">
            {/* <header>条款更新</header> */}
            <div className="terms-con__box">
                <Bscroll scrollX={false} scrollY={true}>
                    <div className="terms-show">
                        <div className="terms-info">
                            <h2 onClick={() => {history.push('/privacytext')}}>
                                <span>《隐私条款》</span>
                                <em>
                                    <img src={rightBtn} alt="" />
                                </em>
                            </h2>
                            <div className="update-info">
                                <h3>本次更新的内容有：</h3>
                                <ul>
                                    <li>1.个人信息的定义和范围</li>
                                    <li>2.我们如何收集您的个人信息 </li>
                                    <li>3.我们如何保存您的个人信息 </li>
                                    <li>4.我们如何使用您的个人信息</li>
                                    <li>5.我们如何共享、转让、公开披露您的个人信息</li>
                                </ul>
                            </div>
                        </div>
                        <div className="terms-info">
                            <h2 onClick={() => {history.push('/service')}}>
                                <span>《出行服务条款》</span>
                                <em>
                                    <img src={rightBtn} alt="" />
                                </em>
                            </h2>
                            <div className="update-info">
                                <h3>本次更新的内容有：</h3>
                                <ul>
                                    <li>1.服务内容</li>
                                    <li>2.费用结算</li>
                                    <li>3.知识产权 </li>
                                    <li>4.产品更新和升级</li>
                                    <li>5.法律适用与管辖</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Bscroll>
            </div>
            {/* <footer>
                <button onClick={handleRejectBtn}>拒绝</button>
                <button>
                    {
                        count < 0 ? <span onClick={handleAcceptBtn}>接受</span> : <span><em>{count}</em>s</span>
                    }
                </button>
            </footer> */}
        </div>
    )
}
// export default connect(mapStateToProps, mapDispatchToProps)(TermsUpdate)
export default TermsUpdate